import { createApp } from 'vue';
import SharpUI from '@lux/sharp-ui-next';
import { addVconsole } from '@/utils/addVconsole';
import App from './App.vue';
import { router } from './router';
import { pinia } from './utils/pinia';
import { logger, initErrorHandlerLog } from './utils/logs';
import '@lux/sharp-ui-next/themes/default';
import '@/assets/styles/global.styl';
import '@/assets/styles/var.styl';
import '@/assets/styles/base.styl';
const app = createApp(App).use(router).use(pinia).use(SharpUI);

addVconsole();

initErrorHandlerLog(app);

app.mount('#app');
app.provide('logger', logger);
